/**
 * 视频截帧配置参数（可选）
 */
interface SnapshotOptions {
  t?: number;               // 截图时间 (ms)，默认 0
  f?: 'jpg' | 'png';        // 格式，默认 png
  w?: number;               // 宽度 (px)
  h?: number;               // 高度 (px)
  m?: 'fast';               // 模式，默认 fast
  ar?: 'auto' | 'h' | 'w';  // 自动旋转
}

/**
 * 构建阿里云 OSS 视频截帧 URL
 * @param videoUrl 原始视频地址
 * @param options 覆盖默认值的配置
 */
export function buildVideoOssFrame(videoUrl: string, options: SnapshotOptions = {}): string {
  // 设置默认值
  const {
    t = 0,
    f = 'png',
    m = 'fast',
    w,
    h,
    ar
  } = options;

  const params: string[] = ['video/snapshot'];

  params.push(`t_${t}`);
  params.push(`f_${f}`);
  params.push(`m_${m}`);

  if (w !== undefined) params.push(`w_${w}`);
  if (h !== undefined) params.push(`h_${h}`);
  if (ar) params.push(`ar_${ar}`);

  // 拼接处理字符串并进行 URL 编码
  // 阿里云要求将 "video/snapshot,t_0,f_png..." 整体编码
  const processStr = params.join(',');
  const xOssProcess = `x-oss-process=${encodeURIComponent(processStr)}`;

  // 智能拼接 URL
  // 判断原 URL 是否已有查询参数（如已带签名的私有链接）
  const separator = videoUrl.includes('?') ? '&' : '?';

  return `${videoUrl}${separator}${xOssProcess}`;
}

// --- 使用示例 ---
// const videoUrl = "https://examplebucket.oss-cn-hangzhou.aliyuncs.com/movie.mp4";
// const frameUrl = buildVideoOssFrame(videoUrl, { t: 15000, w: 400, f: 'jpg' });

// console.log(frameUrl);
// 输出示例: .../movie.mp4?x-oss-process=video%2Fsnapshot%2Ct_15000%2Cf_jpg%2Cw_400